export enum ActivityKind {
  Order = "Order",
  OrderItem = "OrderItem",
  Asset = "Asset",
  Action = "Action",
  Config = "Config",
  UserTask = "UserTask",
  ExternalAccess = "ExternalAccess",
}
